export const CREDIT_CARD_INFO = 'creditCardInfo';
export const CREDIT_CARD_INFO_IS_LOADED = 'isCreditCardLoaded';
export const SUBSCRIPTION_INFO = 'subscriptionInfo';
export const SUBSCRIPTION_INFO_V2 = 'subscriptionInfoV2';
export const SELECTED_TIER = 'selectedTier';
export const SELECTED_DISCOUNT_TYPE = 'selectedDiscountType';
export const SELECTED_PAYMENT_PROVIDER = 'selectedPaymentProvider';
export const CREDIT_CARD_FORM_STATUS = 'creditCardFormStatus';
export const PAYPAL_STATUS = 'paypalStatus';
export const SWITCHING_PLANS = 'isSwitchingPlans';
export const UPDATING_BILLING_INFO = 'isUpdatingBillingInfo';
export const UPDATED_BILLING_INFO = 'updatedBillingInfo';
export const PAYPAL_REDIRECT_URL = 'paypalRedirectUrl';
export const IS_ANONYMOUS_UPGRADE = 'isAnonymousUpgrade';
export const AVAILABLE_PRODUCTS = 'availableProducts';
export const SPECIAL_OFFER_PRODUCTS = 'specialOfferProducts';
export const PP_VENDOR_SKU = 'paypalVendorSku';
export const PP_PRODUCT_ID = 'paypalProductId';
export const PP_TIER = 'tier';
export const PP_DISCOUNT_TYPE = 'discountType';
export const PP_DURATION_TYPE = 'durationType';
export const PP_SPECIAL_OFFER_CODE = 'specialOfferCode';
export const IS_PENDING_PURCHASE = 'isPendingPurchase';
export const PAYPAL_COMPLETE = 'paypalComplete';
export const INVALID_CREDIT_CARD = 'invalidCreditCard';
export const SERVER_ERROR_TYPE = 'serverErrorType';
export const SERVER_ERROR_MESSAGE = 'serverErrorMessage';
export const IS_PENDING_PAYMENT_UPDATE = 'isPendingPaymentUpdate';
export const MOBILE_MESSAGE = 'mobileMessage';
export const PARTNER_UPGRADE_ENTITLEMENT_ID = 'partnerUpgradeEntitlementId';
export const PARTNER_UPGRADE_TIER = 'partnerUpgradeTier';
export const PARTNER_UPGRADE_PARTNER_NAME = 'partnerUpgradePartnerName';
export const PARTNER_UPGRADE_USER_CONFIRMED = 'partnerUpgradeUserConfirmed';
export const PREVIOUS_PLAN = 'previousPlan';
export const FAMILY_PLAN_PARENT_EMAIL = 'familyPlanParentEmail';
